import { useMemo } from 'react';
import { StudyData } from '@/types/types';

export function useTableData(initialData: StudyData[]) {
  const data = useMemo(() => {
    return [...initialData].sort((a, b) => {
      if (!a.StudyDate && !b.StudyDate) return 0;
      if (!a.StudyDate) return 1;
      if (!b.StudyDate) return -1;
      const dateA = new Date(a.StudyDate);
      const dateB = new Date(b.StudyDate);
      return dateB.getTime() - dateA.getTime();
    });
  }, [initialData]);

  return data;
}